import React from 'react';
import {createRoot} from 'react-dom/client';
import {GalleryRootWrapper} from '~/GalleryPB/GalleryRootWrapper';

const container = document.getElementById('gallery_root');
if (container) {
  const root = createRoot(container);
  root.render(<GalleryRootWrapper />);
}
